import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc228b10"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "text-xs",
  "data-cy": "pdf-page-header",
  style: {"margin-top":"2.5px"}
}
const _hoisted_2 = { class: "flex justify-between py-1 header" }
const _hoisted_3 = {
  "data-cy": "header-objNum",
  style: {"width":"30%","text-align":"start","margin-left":"20px"}
}
const _hoisted_4 = {
  "data-cy": "header-title",
  style: {"width":"39%","text-align":"center"}
}
const _hoisted_5 = {
  "data-cy": "header-pages",
  style: {"width":"30%","text-align":"end","margin-right":"20px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner-l" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageCounter = _resolveComponent("PageCounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString("Mast: " + _ctx.immobilie.externeObjektNr), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString("Schadensmeldungen - " +  _ctx.Title), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_PageCounter)
      ])
    ]),
    _hoisted_6
  ]))
}